// reducers
import { initialState } from 'root/stores/boards/schema';
import createReducerExtended from 'utils/createReducerExtended';

import { constants } from '../constants';
import * as reduceCreateBoard from './reduceCreateBoard';
import * as reduceDeactivateBoard from './reduceDeactivateBoard';
import * as reduceReadBoard from './reduceReadBoard';
import * as reduceReadBoardsByOrganization from './reduceReadBoardsByOrganization';
import * as reduceUpdateBoard from './reduceUpdateBoard';

export const reducer = (state = initialState, action) =>
  createReducerExtended(state, action, constants, {
    ...reduceCreateBoard,
    ...reduceDeactivateBoard,
    ...reduceReadBoard,
    ...reduceReadBoardsByOrganization,
    ...reduceUpdateBoard,
  });
